<div #main [tabindex]="disabled? -1: 0" class="ngx-select dropdown"
     [ngClass]="setFormControlSize({
        'ngx-select_multiple form-control': multiple === true,
        'open show': optionsOpened && optionsFiltered.length
     }, multiple === true)"
     (click)="mainClicked($event)" (focusin)="mainClicked($event)"
     (focus)="focusToInput()" (keydown)="inputKeyDown($event)">
    <div [ngClass]="{ 'ngx-select__disabled': disabled}"></div>

    <!-- single selected item -->
    <div class="ngx-select__selected"
         *ngIf="(multiple === false) && (!optionsOpened || noAutoComplete)">
        <div class="ngx-select__toggle btn form-control" [ngClass]="setFormControlSize(setBtnSize())"
             (click)="optionsOpen()">

            <span *ngIf="!optionsSelected.length" class="ngx-select__placeholder text-muted">
                <span [innerHtml]="placeholder"></span>
            </span>
            <span *ngIf="optionsSelected.length"
                  class="ngx-select__selected-single pull-left float-left"
                  [ngClass]="{'ngx-select__allow-clear': allowClear}">
                <ng-container [ngTemplateOutlet]="templateSelectedOption || defaultTemplateOption"
                              [ngTemplateOutletContext]="{$implicit: optionsSelected[0], index: 0,
                                                          text: sanitize(optionsSelected[0].text)}">
                </ng-container>
            </span>
            <span class="ngx-select__toggle-buttons">
                <a class="ngx-select__clear btn btn-sm btn-link" *ngIf="canClearNotMultiple()"
                   [ngClass]="setBtnSize()"
                   (click)="optionRemove(optionsSelected[0], $event)">
                    <i class="ngx-select__clear-icon"></i>
                </a>
                <i class="dropdown-toggle"></i>
                <i class="ngx-select__toggle-caret caret"></i>
            </span>
        </div>
    </div>

    <!-- multiple selected items -->
    <div class="ngx-select__selected" *ngIf="multiple === true" (click)="inputClick(inputElRef && inputElRef['value'])">
        <span *ngFor="let option of optionsSelected; trackBy: trackByOption; let idx = index">
            <span tabindex="-1" [ngClass]="setBtnSize()" (click)="$event.stopPropagation()"
                  class="ngx-select__selected-plural btn btn-default btn-secondary btn-sm btn-xs">

                <ng-container [ngTemplateOutlet]="templateSelectedOption || defaultTemplateOption"
                              [ngTemplateOutletContext]="{$implicit: option, index: idx, text: sanitize(option.text)}">
                </ng-container>

                <a class="ngx-select__clear btn btn-sm btn-link pull-right float-right" [ngClass]="setBtnSize()"
                   (click)="optionRemove(option, $event)">
                    <i class="ngx-select__clear-icon"></i>
                </a>
            </span>
        </span>
    </div>

    <!-- live search an item from the list -->
    <input #input type="text" class="ngx-select__search form-control" [ngClass]="setFormControlSize()"
           *ngIf="checkInputVisibility()"
           [tabindex]="multiple === false? -1: 0"
           (keyup)="inputKeyUp(input.value, $event)"
           [disabled]="disabled"
           [placeholder]="optionsSelected.length? '': placeholder"
           (click)="inputClick(input.value)"
           [autocomplete]="autocomplete"
           autocorrect="off"
           autocapitalize="off"
           spellcheck="false"
           role="combobox">

    <!-- options template -->
    <ul #choiceMenu role="menu" *ngIf="isFocused" class="ngx-select__choices dropdown-menu"
        [ngClass]="dropDownMenuOtherClasses"
        [class.show]="showChoiceMenu()">
        <li class="ngx-select__item-group" role="menuitem"
            *ngFor="let opt of optionsFiltered; trackBy: trackByOption; let idxGroup=index">
            <div class="divider dropdown-divider" *ngIf="opt.type === 'optgroup' && (idxGroup > 0)"></div>
            <div class="dropdown-header" *ngIf="opt.type === 'optgroup'">{{opt.label}}</div>

            <a href="#" #choiceItem class="ngx-select__item dropdown-item"
               *ngFor="let option of (opt.optionsFiltered || [opt]); trackBy: trackByOption; let idxOption = index"
               [ngClass]="{
                    'ngx-select__item_active active': option.active,
                    'ngx-select__item_disabled disabled': option.disabled
               }"
               (mouseenter)="onMouseEnter({
                    activeOption: option,
                    filteredOptionList: optionsFiltered,
                    index: optionsFiltered.indexOf(option)
               })"
               (click)="optionSelect(option, $event)">
                <ng-container [ngTemplateOutlet]="templateOption || defaultTemplateOption"
                              [ngTemplateOutletContext]="{$implicit: option, text: option.highlightedText,
                              index: idxGroup, subIndex: idxOption}"></ng-container>
            </a>
        </li>
        <li class="ngx-select__item ngx-select__item_no-found dropdown-header" *ngIf="!optionsFiltered.length">
            <ng-container [ngTemplateOutlet]="templateOptionNotFound || defaultTemplateOptionNotFound"
                          [ngTemplateOutletContext]="{$implicit: inputText}"></ng-container>
        </li>
    </ul>

    <!--Default templates-->
    <ng-template #defaultTemplateOption let-text="text">
        <span [innerHtml]="text"></span>
    </ng-template>

    <ng-template #defaultTemplateOptionNotFound>
        {{noResultsFound}}
    </ng-template>

</div>
